import styled from 'styled-components';
import { fadeIn } from '../../shared';

const LoadingDotsWrapper = styled.div`
  align-self: center;
  text-align: center;
  display: block;
  vertical-align: middle;

  > div {
    align-self: center;
    text-align: center;
    vertical-align: middle;
  }

  > div > div {
    width: .93em;
    height: .93em;
    opacity: 0.375;
    vertical-align: middle;
  }
`;

const StyledNoContent = styled.div`
  text-align: center;
  font-size: 1.225em;
  color: #B5BBC1;
`;

const StyledModalBodyRow = styled.div`
  padding-bottom: .75rem;
  margin-left: 0;
  margin-right: 0;
  padding-top: .75rem;
  background-clip: border-box;
  box-shadow: 0 0 3px 0 rgba(0,0,0,.075);
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 0;
  animation: ${fadeIn} .3s both ease-in-out;
`;

export {
  LoadingDotsWrapper,
  StyledNoContent,
  StyledModalBodyRow,
}